import React, { Component, createRef } from "react";
import ReactDOM from "react-dom";
import { Modal, Button, Form } from "react-bootstrap";
import './StornoDialog.css';
import { I18n, Translate } from "react-redux-i18n";
import Select from 'react-select';
import { getLocale } from "react-schema-based-json-editor";
import { _preProcessOrders, allstates } from "../js/order-grouping";
import auth from "../js/auth";
import { update } from "lodash";


class StornoDialog extends Component {

  // Refs for all input fields
  receiptNumberRef = createRef();
  apRef = createRef();
  customerTaxNumRef = createRef();
  customerNameRef = createRef();
  customerPostCodeRef = createRef();
  customerTownRef = createRef();
  customerAddressRef = createRef();

  // Clear field helper for X button, then focus the field
  clearField = (field) => {
    const state = {};
    state[field] = "";
    this.setState(state, () => {
      // Focus the field after clearing
      if (field === "receiptNumber" && this.receiptNumberRef.current) this.receiptNumberRef.current.focus();
      if (field === "ap" && this.apRef.current) this.apRef.current.focus();
      if (field === "customerTaxNum" && this.customerTaxNumRef.current) this.customerTaxNumRef.current.focus();
      if (field === "customerName" && this.customerNameRef.current) this.customerNameRef.current.focus();
      if (field === "customerPostCode" && this.customerPostCodeRef.current) this.customerPostCodeRef.current.focus();
      if (field === "customerTown" && this.customerTownRef.current) this.customerTownRef.current.focus();
      if (field === "customerAddress" && this.customerAddressRef.current) this.customerAddressRef.current.focus();
    });
    // Special handling for receiptNumber: also trigger receiptNoChanged
    if (field === "receiptNumber") {
      this.props.receiptNoChanged("")
        .done((data) => {
          if (data.tableMatePayment) {
            let processedOrders = null;
            if (data.tableMatePayment?.orders) {
              processedOrders = _preProcessOrders(
                this.filterOrders(data.tableMatePayment.orders),
                allstates,
                () => true,
                data.tableOccupation,
                data.tableMatePayment.tableMate
              );
            }
            let ordersSelected = processedOrders ? processedOrders.ordersByMenuItem.map(order => order.orders.map(o => o.id)).flat() : [];
            const totalPrice = processedOrders ? processedOrders.ordersByMenuItem.reduce((sum, order, idx) => {
              const stornoCount = this.state.stornoCounts[idx] || 0;
              const rowTotal = Number(order.price) * stornoCount;
              return sum + rowTotal;
            }, 0) : 0;
            this.setState({
              receiptNumber: data.receiptNo !== undefined ? data.receiptNo : this.state.receiptNumber,
              tableMatePayment: data.tableMatePayment,
              tableOccupation: data.tableOccupation,
              processedOrders,
              ordersSelected,
              totalPrice
            });
          } else {
            if (data.receiptNo !== undefined)
              this.setState({
                receiptNumber: data.receiptNo
              });
          }
        })
        .fail((data) => {
          this.setState({ tableMatePayment: undefined, tableOccupation: undefined, mode: 'storno', preProcessOrders: [], ordersSelected: [] });
          if (data?.receiptNo !== undefined)
            this.setState({
              receiptNumber: data.receiptNo
            });
        });
    }
    if (field === "ap") {
      localStorage.ap = "";
    }
  }
  receiptNumberRef = createRef();
  handleStornoCountChange = (orderId, value, maxCount) => {
    let count = parseInt(value, 10);
    if (isNaN(count) || count < 0) count = 0;
    if (count > maxCount) count = maxCount;
    this.setState(prevState => ({
      stornoCounts: {
        ...prevState.stornoCounts,
        [orderId]: count
      }
    }));
  }

  incrementStorno = (index, order, maxCount) => {
    this.setState(prevState => {
      const current = prevState.stornoCounts[index] || 0;
      // Create a new object to avoid mutating the same reference
      const newStornoCounts = { ...prevState.stornoCounts };
      newStornoCounts[index] = current < maxCount ? current + 1 : maxCount;
      const orderIds = order.orders.map(o => o.id);
      //get the first newStornoCounts[index] orderIds from orderIds
      const ordersSelected = orderIds.slice(0, newStornoCounts[index]);
      const totalPrice = this.state.processedOrders.ordersByMenuItem.reduce((sum, order, idx) => {
        const stornoCount = newStornoCounts[idx] || 0;
        const rowTotal = Number(order.price) * stornoCount;
        return sum + rowTotal;
      }, 0);
      return { stornoCounts: newStornoCounts, ordersSelected: [...this.state.ordersSelected.filter(i => !orderIds.includes(i)), ...ordersSelected], totalPrice };
    });
  }

  decrementStorno = (index, order) => {
    this.setState(prevState => {
      const current = prevState.stornoCounts[index] || 0;
      // Create a new object to avoid mutating the same reference
      const newStornoCounts = { ...prevState.stornoCounts };
      newStornoCounts[index] = current > 0 ? current - 1 : 0;
      const orderIds = order.orders.map(o => o.id);
      //get the first newStornoCounts[index] orderIds from orderIds
      const ordersSelected = orderIds.slice(0, newStornoCounts[index]);
      const totalPrice = this.state.processedOrders.ordersByMenuItem.reduce((sum, order, idx) => {
        const stornoCount = newStornoCounts[idx] || 0;
        const rowTotal = Number(order.price) * stornoCount;
        return sum + rowTotal;
      }, 0);
      return { stornoCounts: newStornoCounts, ordersSelected: [...this.state.ordersSelected.filter(i => !orderIds.includes(i)), ...ordersSelected], totalPrice };
    });
  }
  state = {
    show: this.props.show,
    reason: undefined,
    ap: localStorage.ap ? localStorage.ap : "",
    receiptNumber: "",
    customerTaxNum: "",
    customerName: "",
    customerPostCode: "",
    customerTown: "",
    customerAddress: "",
    stornoCounts: {}, // { orderId: count }
    paymentMethod: this.getDefaultPaymentMethod(this.props.tableMatePayment),
    mode: 'storno' // 'storno' or 'refund'
  };

  getDefaultPaymentMethod(tableMatePayment) {
    // Try to get original payment type from payments array, fallback to 'cash'
    if (tableMatePayment && Array.isArray(tableMatePayment.payments)) {
      const payment = tableMatePayment.payments.find(p => p && p.amount > 0 && p.paymentMethod && p.paymentMethod.type);
      if (payment) {
        const type = payment.paymentMethod.type.toLowerCase();
        if (["card", "cash"].includes(type)) return type;
        if (type.includes("card")) return "card";
        if (type.includes("cash")) return "cash";
      }
    }
    return "cash";
  }

  constructor(props) {
    super(props);
    this.state.receiptNumber = props.receiptNo || "";
    this.state.tableMatePayment = props.tableMatePayment;
    this.state.tableOccupation = props.tableOccupation;
    this.state.show = this.props.show;
    // Set default stornoCounts to original count for each order
    if (props.tableMatePayment?.orders) {
      const processed = _preProcessOrders(this.filterOrders(props.tableMatePayment.orders), allstates, () => true, props.tableOccupation, props.tableMatePayment.tableMate);
      const stornoCounts = {};
      processed.ordersByMenuItem.forEach((order, idx) => {
        stornoCounts[idx] = order.orders.length;
      });
      this.state.stornoCounts = stornoCounts;
      this.state.processedOrders = processed;
      this.state.ordersSelected = processed.ordersByMenuItem.map(order => order.orders.map(o => o.id)).flat();
    }
  }

  unmount() {
    ReactDOM.unmountComponentAtNode(this.props.container);
  }

  componentDidMount() {
    this.update();
  }

  componentDidUpdate(prevProps, prevState) {
    this.update(prevProps, prevState);
  }

  update = (prevProps, prevState) => {
    // Focus receiptNumber input when modal is shown
    if (!prevState?.show && this.state.show && this.receiptNumberRef.current) {
      this.receiptNumberRef.current.focus();
    }

    // Existing logic for updating stornoCounts if new orders are loaded
    if (this.state.tableMatePayment !== prevState?.tableMatePayment && this.state.tableMatePayment?.orders) {
      const processed = _preProcessOrders(this.filterOrders(this.state.tableMatePayment.orders), allstates, () => true, this.state.tableOccupation, this.state.tableMatePayment.tableMate);
      const stornoCounts = {};
      processed.ordersByMenuItem.forEach((order, idx) => {
        stornoCounts[idx] = order.orders.length;
      });
      // Only update if different
      if (JSON.stringify(stornoCounts) !== JSON.stringify(prevState?.stornoCounts)) {
        const totalPrice = processed.ordersByMenuItem.reduce((sum, order, idx) => {
          const stornoCount = stornoCounts[idx] || 0;
          const rowTotal = Number(order.price) * stornoCount;
          return sum + rowTotal;
        }, 0);
        this.setState({ stornoCounts, totalPrice, processedOrders: processed, ordersSelected: processed.ordersByMenuItem.map(order => order.orders.map(o => o.id)).flat() });
      }
    }

  }

  inputChange = event => {
    this.setState({ input: event.currentTarget.value })
  }


  render() {
    // Payment method options
    const paymentOptions = [
      { value: "card", label: I18n.t("admin_local.card") },
      { value: "cash", label: I18n.t("admin_local.cash") }
    ];

    // Mode selector UI
    const modeOptions = [
      { value: 'storno', label: I18n.t('admin_local.storno') || 'Storno' },
      { value: 'refund', label: I18n.t('admin_local.return_and_refund') || 'Return and Refund' }
    ];

    const options = this.state.mode === 'storno' ? [
      { value: "1", label: I18n.t("admin_local.stornoreason_1") },
      { value: "2", label: I18n.t("admin_local.stornoreason_2") },
      { value: "3", label: I18n.t("admin_local.stornoreason_3") },
      { value: "4", label: I18n.t("admin_local.stornoreason_4") },
      { value: "5", label: I18n.t("admin_local.stornoreason_5") },
      { value: "6", label: I18n.t("admin_local.stornoreason_6") },
      { value: "7", label: I18n.t("admin_local.stornoreason_7") },
      { value: "8", label: I18n.t("admin_local.stornoreason_8") },
      { value: "0", label: I18n.t("admin_local.stornoreason_0") }
    ] : [
      { value: "1", label: I18n.t("admin_local.refundreason_1") },
      { value: "2", label: I18n.t("admin_local.refundreason_2") },
      { value: "3", label: I18n.t("admin_local.refundreason_3") },
    ];
    if (this.state.show === false) {
      return null;
    }

    let processedOrders = this.state.processedOrders;
    let totalPrice = this.state.totalPrice || 0;

    return (
      <Modal
        style={{ zIndex: 10000 }}
        show={this.state.show}
        onHide={this.props.def.reject}
        centered
        dialogClassName="storno-modal-dialog"
      >
        <Modal.Header className="eatwithme no-close">
          {this.state.tableMatePayment ?
            modeOptions.map(opt => (
              <Button
                key={opt.value}
                variant={this.state.mode === opt.value ? "warning" : "outline-secondary"}
                className={this.state.mode === opt.value ? "active" : ""}
                onClick={() => this.setState({ mode: opt.value, reason: undefined })}
                style={{ minWidth: 160, marginRight: 8, fontSize: '20px' }}
              >
                {opt.label}
              </Button>
            )) : (<h1>{this.state.mode === 'storno' ? I18n.t("admin_local.storno") : I18n.t("admin_local.return_and_refund")}</h1>)
          }

        </Modal.Header>
        <Modal.Body style={{ fontSize: "27px" }}>
          <Form.Group className="mb-3">
            <div style={{ position: 'relative' }}>
              <Form.Control
                ref={this.receiptNumberRef}
                onChange={this.change}
                id="receiptNumber"
                value={this.state.receiptNumber}
                type="text"
                placeholder={I18n.t("admin_local.receiptNumber")}
                autoComplete="off"
              />
              {this.state.receiptNumber && (
                <Button
                  variant="light"
                  size="sm"
                  style={{ position: 'absolute', right: 4, top: '41%', transform: 'translateY(-50%)', padding: '0 6px', zIndex: 2 }}
                  onClick={() => this.clearField('receiptNumber')}
                  tabIndex={-1}
                >
                  ×
                </Button>
              )}
            </div>

            {processedOrders && (() => {
              // Calculate total price summary using storno quantities and per-row storno price
              return (
                <table className="table table-bordered" style={{ background: 'white', fontSize: '22px', marginTop: '15px' }}>
                  <thead>
                    <tr>
                      <th>{I18n.t('admin_local.product')}</th>
                      <th style={{ textAlign: 'center' }}>{I18n.t('admin_local.original_quantity') || 'Original quantity'}</th>
                      <th style={{ textAlign: 'center' }}>{I18n.t('admin_local.price')}</th>
                      {this.state.mode === 'refund' && <th style={{ textAlign: 'center' }}>{I18n.t('admin_local.quantity')}</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {processedOrders.ordersByMenuItem.map((order, idx) => {
                      const maxCount = order.orders.length;
                      const stornoCount = this.state.stornoCounts[idx] || 0;
                      return (
                        <tr key={idx}>
                          <td>{getLocale(order.menuItem.name)}</td>
                          <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{maxCount}</td>
                          <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{auth.round(Number(order.price) * (this.state.stornoCounts[idx] || 0))}</td>
                          {this.state.mode === 'refund' && (
                            <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
                                <Button
                                  variant="secondary"
                                  size="sm"
                                  style={{ fontSize: '22px', width: '36px', height: '36px', padding: 0 }}
                                  onClick={() => this.decrementStorno(idx, order)}
                                  disabled={stornoCount <= 0}
                                >
                                  -
                                </Button>
                                <span style={{ minWidth: '32px', textAlign: 'center', fontSize: '22px', display: 'inline-block' }}>{stornoCount}</span>
                                <Button
                                  variant="secondary"
                                  size="sm"
                                  style={{ fontSize: '22px', width: '36px', height: '36px', padding: 0 }}
                                  onClick={() => this.incrementStorno(idx, order, maxCount)}
                                  disabled={stornoCount >= maxCount}
                                >
                                  +
                                </Button>
                              </div>
                            </td>)}
                        </tr>
                      );
                    })}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td style={{ fontWeight: 600, textAlign: 'right' }} colSpan={2}>{I18n.t('admin_local.total') || 'Total'}:</td>
                      <td style={{ fontWeight: 600, textAlign: 'center' }}>{auth.round(totalPrice)}</td>
                      {this.state.mode === 'refund' && <td></td>}
                    </tr>
                  </tfoot>
                </table>
              );
            })()}
            <Select
              key={this.state.mode}
              id="reason"
              onChange={this.optionChange}
              options={options}
              value={options.find(opt => opt.value === String(this.state.reason))}
              placeholder={this.state.mode === 'storno' ? I18n.t("admin_local.stornoreason") : I18n.t("admin_local.refundreason")}
            />
            <div style={{ position: 'relative', marginTop: 8 }}>
              <Form.Control
                ref={this.apRef}
                onChange={this.apchange}
                id="ap"
                value={this.state.ap}
                type="text"
                placeholder={I18n.t("admin_local.ap")}
                autoComplete="off"
              />
              {this.state.ap && (
                <Button
                  variant="light"
                  size="sm"
                  style={{ position: 'absolute', right: 4, top: '41%', transform: 'translateY(-50%)', padding: '0 6px', zIndex: 2 }}
                  onClick={() => this.clearField('ap')}
                  tabIndex={-1}
                >
                  ×
                </Button>
              )}
            </div>
            {/* ...existing code... */}
            <div style={{ position: 'relative', marginTop: 8 }}>
              <Form.Control
                ref={this.customerTaxNumRef}
                onChange={this.change}
                id="customerTaxNum"
                value={this.state.customerTaxNum}
                type="text"
                placeholder={I18n.t("admin_local.customerTaxNum")}
                autoComplete="off"
              />
              {this.state.customerTaxNum && (
                <Button
                  variant="light"
                  size="sm"
                  style={{ position: 'absolute', right: 4, top: '41%', transform: 'translateY(-50%)', padding: '0 6px', zIndex: 2 }}
                  onClick={() => this.clearField('customerTaxNum')}
                  tabIndex={-1}
                >
                  ×
                </Button>
              )}
            </div>
            <div style={{ position: 'relative', marginTop: 8 }}>
              <Form.Control
                ref={this.customerNameRef}
                onChange={this.change}
                id="customerName"
                value={this.state.customerName}
                type="text"
                placeholder={I18n.t("admin_local.customerName")}
                autoComplete="off"
              />
              {this.state.customerName && (
                <Button
                  variant="light"
                  size="sm"
                  style={{ position: 'absolute', right: 4, top: '41%', transform: 'translateY(-50%)', padding: '0 6px', zIndex: 2 }}
                  onClick={() => this.clearField('customerName')}
                  tabIndex={-1}
                >
                  ×
                </Button>
              )}
            </div>
            <div style={{ position: 'relative', marginTop: 8 }}>
              <Form.Control
                ref={this.customerPostCodeRef}
                onChange={this.change}
                id="customerPostCode"
                value={this.state.customerPostCode}
                type="text"
                placeholder={I18n.t("admin_local.customerPostCode")}
                autoComplete="off"
              />
              {this.state.customerPostCode && (
                <Button
                  variant="light"
                  size="sm"
                  style={{ position: 'absolute', right: 4, top: '41%', transform: 'translateY(-50%)', padding: '0 6px', zIndex: 2 }}
                  onClick={() => this.clearField('customerPostCode')}
                  tabIndex={-1}
                >
                  ×
                </Button>
              )}
            </div>
            <div style={{ position: 'relative', marginTop: 8 }}>
              <Form.Control
                ref={this.customerTownRef}
                onChange={this.change}
                id="customerTown"
                value={this.state.customerTown}
                type="text"
                placeholder={I18n.t("admin_local.customerTown")}
                autoComplete="off"
              />
              {this.state.customerTown && (
                <Button
                  variant="light"
                  size="sm"
                  style={{ position: 'absolute', right: 4, top: '41%', transform: 'translateY(-50%)', padding: '0 6px', zIndex: 2 }}
                  onClick={() => this.clearField('customerTown')}
                  tabIndex={-1}
                >
                  ×
                </Button>
              )}
            </div>
            <div style={{ position: 'relative', marginTop: 8 }}>
              <Form.Control
                ref={this.customerAddressRef}
                onChange={this.change}
                id="customerAddress"
                value={this.state.customerAddress}
                type="text"
                placeholder={I18n.t("admin_local.customerAddress")}
                autoComplete="off"
              />
              {this.state.customerAddress && (
                <Button
                  variant="light"
                  size="sm"
                  style={{ position: 'absolute', right: 4, top: '41%', transform: 'translateY(-50%)', padding: '0 6px', zIndex: 2 }}
                  onClick={() => this.clearField('customerAddress')}
                  tabIndex={-1}
                >
                  ×
                </Button>
              )}
            </div>
            {/* Payment method selection (moved to end, centered) */}
            {this.state.mode === 'refund' && (
              <div style={{ margin: '15px 0', textAlign: 'center' }}>
                <div style={{ fontWeight: 600, marginBottom: 6 }}>{I18n.t(this.state.mode === 'storno' ? "admin_local.storno_payment_method" : "admin_local.refund_payment_method") || "Refund payment method"}:</div>
                <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                  {paymentOptions.map(opt => (
                    <Button
                      key={opt.value}
                      variant={this.state.paymentMethod === opt.value ? "warning" : "outline-secondary"}
                      className={this.state.paymentMethod === opt.value ? "active" : ""}
                      onClick={() => this.state.mode === 'refund' && this.setState({ paymentMethod: opt.value })}
                      style={{ minWidth: 90 }}
                      disabled={this.state.mode === 'storno'}
                    >
                      {opt.label}
                    </Button>
                  ))}
                </div>
              </div>)}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          {/* Mode selector */}

          {this.props.buttons.map((button, ind) => {
            return (
              <Button
                key={ind}
                onClick={() => {
                  this.unmount();
                  this.props.def.resolve(this.state);
                }}
              >
                <Translate value={button} />
              </Button>
            );
          })}
          <Button
            variant="danger"
            onClick={() => {
              this.unmount();
              this.props.def.reject();
            }}
          >
            <Translate value="local.cancel" />
          </Button>
        </Modal.Footer>
      </Modal >
    );
  }
  // ...existing code...
  optionChange = (event) => {
    this.setState({ reason: event.value });

  }
  change = (event) => {
    const state = {};
    state[event.currentTarget.id] = event.currentTarget.value;
    this.setState(state);
    if (event.currentTarget.id === "receiptNumber") {
      this.props.receiptNoChanged(event.currentTarget.value)
        .done((data) => {
          if (data.tableMatePayment) {
          // Cache processed orders to avoid recalculating
          let processedOrders = null;
          if (data.tableMatePayment?.orders) {
            processedOrders = _preProcessOrders(
              this.filterOrders(data.tableMatePayment.orders),
              allstates,
              () => true,
              data.tableOccupation,
              data.tableMatePayment.tableMate
            );
          }
          let ordersSelected = processedOrders.ordersByMenuItem.map(order => order.orders.map(o => o.id)).flat();
          const totalPrice = processedOrders.ordersByMenuItem.reduce((sum, order, idx) => {
            const stornoCount = this.state.stornoCounts[idx] || 0;
            const rowTotal = Number(order.price) * stornoCount;
            return sum + rowTotal;
          }, 0);
            this.setState({
              receiptNumber: data.receiptNo !== undefined ? data.receiptNo : this.state.receiptNumber,
              tableMatePayment: data.tableMatePayment,
              tableOccupation: data.tableOccupation,
              processedOrders,
              ordersSelected,
              totalPrice
            });
          } else {
            if (data.receiptNo !== undefined)
              this.setState({
                receiptNumber: data.receiptNo
              });
          }
        })
        .fail((data) => {
          this.setState({ tableMatePayment: undefined, tableOccupation: undefined, mode: 'storno', preProcessOrders: [], ordersSelected: [] });
          if (data?.receiptNo !== undefined)
            this.setState({
              receiptNumber: data.receiptNo
            });
        });
    }
  }
  apchange = (event) => {
    const state = {};
    state[event.currentTarget.id] = event.currentTarget.value;
    localStorage.ap = event.currentTarget.value;
    this.setState(state)

  }
  filterOrders(orders) {
    // Filter orders to only include those that are in 'served' or 'paid' state
    return orders.filter(order => {
      return order.paid && order.refundTableMatePaymentId == null;
    });
  }
}

export default StornoDialog;
